import React, { Component } from 'react';
import { compose } from 'redux';
import axios from 'axios';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as Cookies from 'js-cookie';
import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon';
import ButtonMenu from 'components/buttons/ButtonMenu';
import MenuItem from 'components/Menu/MenuItem';
import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import SearchInput from 'components/forms/SearchInput';
import LoadingIcon from 'mdi-react/LoadingIcon';
import Select from 'components/forms/Select';
import Button from 'components/buttons/Button';
import Table from 'components/tables';
import TableHead from 'components/tables/tableHead';
import TableBody from 'components/tables/tableBody';
import TableSortLabel from 'components/tables/tableSortLabel';
import TableCell from 'components/tables/tableCell';
import TableRow from 'components/tables/tableRow';
import Checkbox from 'components/forms/Checkbox';
import AlertOutlineIcon from 'mdi-react/AlertOutlineIcon';
import NoResults from 'components/NoResults';
import Switch from 'components/forms/Switch';
import { StepsFilter, DynamicFilter } from 'components/filters';
import HideFields from 'components/Coverage/HideFields';
import DateRangePicker from 'components/forms/DateRangePicker';
import { isEmpty, first, get } from 'lodash';

import Pagination from 'components/pagination/Pagination';
import { resultsToOptions, flattenKeyPairArray, uuidv4, removeTZ, downloadBlob } from 'utils/misc';
import { CONTACT_ERRORS } from 'constants/contact';
import { MODAL_TYPES } from 'constants/sequenceContact';
import { SELECT_ALL_SUCCESS } from 'constants/config';
import {
  destroySequenceContact, updateSequenceContact,
  removeFromCampaignSequenceContact, removeBulkFromCampaignSequenceContact,
  updateBulkSequenceContact, destroyBulkSequenceContact, markAsFinishedSequenceContact,
  unmarkAsFinishedSequenceContact, markBulkAsFinishedSequenceContact,
  unmarkBulkAsFinishedSequenceContact,
} from 'redux/actions/sequenceContactActions';
import { getSequenceErrorsCSVLink } from 'utils/sequence';
import { updateSequence, getSequences } from 'redux/actions/sequenceActions';
import {
  createAccountBlacklistedContact, createBulkAccountBlacklistedContacts,
} from 'redux/actions/accountBlacklistedContactActions';
import withContactList from 'components/ContactList/withContactList';
import { Can, AbilityContext } from 'utils/permissions';
import {
  REPLY_STATUS_OPTIONS,
  EMAIL_VALIDATION_STATUS_OPTIONS,
  DELIVERY_STATUS_OPTIONS,
  DELIVERY_STATUS_CRITERIA_OPTIONS,
} from 'constants/outreach';

import ContactStatsSlim from 'containers/Sequences/SequenceDetail/ContactsTab/ContactStatsSlim';
import { DEFAULT_CONTACT_QUERY_PARAMS } from 'containers/Accounts/AccountDetail/ContactsTab/index';
import ContactUpdateDrawer from 'components/contact/ContactUpdateDrawer';
import { apiExportSequenceContacts } from 'constants/apiRouting';
import ActionsModal from './ActionsModal';
import ActionsBulkModal from './ActionsBulkModal';
import ContactsLoader from '../ContactsLoader';
import ContactRow from './ContactRow';


const DYNAMIC_MENU_OPTIONS = {
  category: 'category',
  validationStatus: 'validationStatuses',
  deliveryStatus: 'deliveryStatuses',
  stepIds: 'stepIds',
  showErrors: 'showErrors',
  added: 'added',
  lastDelivered: 'lastDelivered',
};

const DEFAULT_DELIVERY_STATUS_CRITERIA = first(DELIVERY_STATUS_CRITERIA_OPTIONS);

class SequenceContactList extends Component {
  static propTypes = {
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      account_id: PropTypes.number,
      campaign: PropTypes.number,
    }).isRequired,
    sequences: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      count: PropTypes.number,
      next: PropTypes.string,
      previous: PropTypes.string,
      results: PropTypes.array,
    }).isRequired,
    contacts: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      results: PropTypes.array,
    }).isRequired,
    sequenceContacts: PropTypes.shape({
      count: PropTypes.number,
    }).isRequired,
    getContacts: PropTypes.func.isRequired,
    destroySequenceContact: PropTypes.func.isRequired,
    createAccountBlacklistedContact: PropTypes.func.isRequired,
    removeFromCampaignSequenceContact: PropTypes.func.isRequired,
    removeBulkFromCampaignSequenceContact: PropTypes.func.isRequired,
    markAsFinishedSequenceContact: PropTypes.func.isRequired,
    markBulkAsFinishedSequenceContact: PropTypes.func.isRequired,
    unmarkAsFinishedSequenceContact: PropTypes.func.isRequired,
    unmarkBulkAsFinishedSequenceContact: PropTypes.func.isRequired,
    updateBulkSequenceContact: PropTypes.func.isRequired,
    destroyBulkSequenceContact: PropTypes.func.isRequired,
    createBulkAccountBlacklistedContacts: PropTypes.func.isRequired,
    getSequences: PropTypes.func.isRequired,
    updateSequence: PropTypes.func.isRequired,
    showDuplicates: PropTypes.bool,
    showDownloadErrors: PropTypes.bool,
    showSteps: PropTypes.bool,
    showContactReplyForCurrentSequence: PropTypes.bool,
    getSelectedContactsOnPage: PropTypes.func.isRequired,
    handleSelectClick: PropTypes.func.isRequired,
    showNotification: PropTypes.func.isRequired,
    untoggleSelectedContactOnPage: PropTypes.func.isRequired,
    isSelected: PropTypes.func.isRequired,
    isAllChecked: PropTypes.func.isRequired,
    isIndeterminate: PropTypes.func.isRequired,
    handleSelectAll: PropTypes.func.isRequired,
    isSelectedAllContacts: PropTypes.bool.isRequired,
    onSelectedAllContacts: PropTypes.func.isRequired,
    removeSelection: PropTypes.func.isRequired,
    onClickAddContact: PropTypes.func.isRequired,
  };

  static defaultProps = {
    showDuplicates: true,
    showDownloadErrors: true,
    showContactReplyForCurrentSequence: false,
    showSteps: false,
  };

  static contextType = AbilityContext;

  constructor(props, context) {
    super(props, context);
    const showFields = JSON.parse(Cookies.get('sequenceContactsShowFields') || '{}');

    this.state = {
      filterParams: {
        search: '',
        statuses: null,
        validationStatuses: null,
        deliveryStatuses: null,
        deliveryStatusCriteria: DEFAULT_DELIVERY_STATUS_CRITERIA,
        startAddedDate: null,
        endAddedDate: null,
        startLastDeliveredDate: null,
        endLastDeliveredDate: null,
        ordering: null,
      },
      selectedIds: new Set(),
      isModalOpen: false,
      isBulkModalOpen: false,
      whichModal: null, // defines which type of modal is open
      // seqContact for modals' actions
      whichSeqContact: { id: null, email: null },
      sequenceToMove: null, // defines to which sequence sequenceContact will be moved
      isContactEditModalOpen: false,
      contactUpdating: {},
      orderState: 'asc',
      fieldsToShow: {
        ...(props.showSteps ? {
          stepSent: {
            show: isEmpty(showFields) || showFields.stepSent,
            label: 'Step sent',
            orderingField: 'step_sent',
            headerContent: (
              <div className="flex items-center">
                Step sent
                <a
                  // eslint-disable-next-line max-len
                  href="https://help.prvolt.com/en/articles/5455217-what-are-steps-in-contacts-and-pitches-and-how-do-they-work"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-1"
                >
                  <HelpOutlineRoundedIcon className="w-4 text-gray-400 hover:text-blue-900" />
                </a>
              </div>
            ),
          },
        }
          : {}
        ),
        deliveryStatus: {
          show: isEmpty(showFields) || showFields.deliveryStatus,
          label: 'Delivery Status',
          orderingField: 'delivery_status',
          headerContent: (
            <div className="flex items-center">
              Delivery Status
              <a
                // eslint-disable-next-line max-len
                href="https://help.prvolt.com/en/articles/4618926-analytics-definitions"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1"
              >
                <HelpOutlineRoundedIcon className="w-4 text-gray-400 hover:text-blue-900" />
              </a>
            </div>
          ),
        },
        inboxCategory: {
          show: isEmpty(showFields) || showFields.inboxCategory,
          label: 'Inbox Category',
          orderingField: 'inbox_category',
          headerContent: (
            <div className="flex items-center">
              Inbox Category
              <a
                // eslint-disable-next-line max-len
                href="https://help.prvolt.com/en/articles/4618926-analytics-definitions"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1"
              >
                <HelpOutlineRoundedIcon className="w-4 text-gray-400 hover:text-blue-900" />
              </a>
            </div>
          ),
        },
        delivered: {
          show: isEmpty(showFields) || showFields.delivered,
          label: 'Delivered',
          orderingField: 'delivered_count',
          align: 'right',
        },
        opens: {
          show: isEmpty(showFields) || showFields.opens,
          label: 'Opens',
          orderingField: 'opens_count',
          align: 'right',
        },
        replies: {
          show: isEmpty(showFields) || showFields.replies,
          label: 'Replies',
          orderingField: 'replies_count',
          align: 'right',
        },
        contactSubject: {
          show: showFields.contactSubject,
          label: 'Contact Subject',
          orderingField: 'contact_subject',
        },
        outletType: {
          show: showFields.outletType,
          label: 'Outlet Type',
          orderingField: 'outlet.outlet_type',
        },
        uvpm: {
          show: showFields.uvpm,
          label: 'UVPM',
          orderingField: 'outlet.unique_monthly_visitors',
        },
        audience: {
          show: showFields.audience,
          label: 'Audience',
          orderingField: 'outlet.audience',
        },
        da: {
          show: showFields.da,
          label: 'DA',
          orderingField: 'outlet.domain_authority',
        },
        country: {
          show: showFields.country,
          label: 'Country',
          orderingField: 'outlet.country',
        },
        dma: {
          show: showFields.dma,
          label: 'DMA',
          orderingField: 'outlet.dma',
        },
        // keyword: {
        //   show: isEmpty(showFields) || showFields.keyword,
        //   label: 'Keyword',
        //   orderingField: 'keyword',
        // },
        // other: {
        //   show: isEmpty(showFields) || showFields.other,
        //   label: 'Other',
        //   orderingField: 'other',
        // },
        // custom1: {
        //   show: isEmpty(showFields) || showFields.custom1,
        //   label: 'Custom 1',
        //   orderingField: 'custom_1',
        // },
        // custom2: {
        //   show: isEmpty(showFields) || showFields.custom2,
        //   label: 'Custom 2',
        //   orderingField: 'custom_2',
        // },
        // custom3: {
        //   show: isEmpty(showFields) || showFields.custom3,
        //   label: 'Custom 3',
        //   orderingField: 'custom_3',
        // },
        // competitor: {
        //   show: isEmpty(showFields) || showFields.competitor,
        //   label: 'Competitor',
        //   orderingField: 'competitor',
        // },
      },
      isExporting: false,
    };
    this.parentComponentId = uuidv4(); // preventing duplicated popover IDs when reusing component multiple times
    // we will check for difference in selectedText
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleBulkModal = this.toggleBulkModal.bind(this);
    this.toggleContactEditModal = this.toggleContactEditModal.bind(this);
    this.fetchContacts = this.fetchContacts.bind(this);

    // will be used to hide all popovers (dirty hack)
    // it will allow us to open 'areYouSure' type modal and at the same time close all 'legacy' type popovers
    this.mainModalRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.isSelectedAllContacts && !this.props.isAllChecked()) {
      this.props.handleSelectAll();
    }
  }

  onResetSelectedFilter = (filter) => {
    const newParams = {};
    switch (filter) {
      case DYNAMIC_MENU_OPTIONS.category:
        newParams.statuses = null;
        break;
      case DYNAMIC_MENU_OPTIONS.validationStatus:
        newParams.validationStatuses = null;
        break;
      case DYNAMIC_MENU_OPTIONS.deliveryStatus:
        newParams.deliveryStatuses = null;
        newParams.deliveryStatusCriteria = DEFAULT_DELIVERY_STATUS_CRITERIA;
        break;
      case DYNAMIC_MENU_OPTIONS.step:
        newParams.stepIds = null;
        break;
      case DYNAMIC_MENU_OPTIONS.added:
        newParams.startAddedDate = null;
        newParams.endAddedDate = null;
        break;
      case DYNAMIC_MENU_OPTIONS.lastDelivered:
        newParams.startLastDeliveredDate = null;
        newParams.endLastDeliveredDate = null;
        break;
      default:
        break;
    }
    this.setState({ filterParams: { ...this.state.filterParams, ...newParams } });
    this.props.removeSelection();
  }

  toggleBulkModal(isOpen, whichModal = null) {
    this.setState({ isBulkModalOpen: isOpen });
    if (whichModal) {
      this.setState({ whichModal });
    }
    // nullify modal state values
    if (this.state.sequenceToMove) {
      this.setState({ sequenceToMove: null });
    }
  }

  toggleModal(isOpen, whichModal = null, seqContact = null) {
    // hide all popovers
    if (this.props.showDuplicates) {
      this.mainModalRef.current.click();
    }
    this.setState({ isModalOpen: isOpen });
    if (whichModal) {
      this.setState({ whichModal });
    }
    if (seqContact) {
      this.setState({ whichSeqContact: seqContact });
    }
    // nullify modal state values
    if (this.state.sequenceToMove) {
      this.setState({ sequenceToMove: null });
    }
  }


  handleChangeSequence = (sequence) => {
    const sequenceToMove = this.props.sequences.results.filter(seq => seq.id === sequence.value)[0];
    this.setState({ sequenceToMove });
  }

  handleLoadSequenceOptions = async (filterString) => {
    await this.props.getSequences(this.props.sequence.campaign, { search: filterString });
    return resultsToOptions(this.props.sequences.results, 'name') || [];
  }

  handleAllowDuplicates = async () => {
    const { sequence } = this.props;
    const { filterParams } = this.state;
    await this.props.updateSequence(sequence.id, { allow_duplicates: !sequence.allow_duplicates });
    await this.props.getContacts(filterParams);
  }

  handleChangeCategories = (statuses) => {
    const paramsForState = { ...this.state.filterParams, statuses };
    this.setState({ filterParams: paramsForState }, this.fetchContacts);
  }

  handleChangeValidationStatus = (validationStatuses) => {
    const paramsForState = { ...this.state.filterParams, validationStatuses };
    this.setState({ filterParams: paramsForState }, this.fetchContacts);
  }

  handleChangeDeliveryStatuses = (deliveryStatuses) => {
    const paramsForState = { ...this.state.filterParams, deliveryStatuses };
    this.setState({ filterParams: paramsForState }, this.fetchContacts);
  }

  handleChangeDeliveryStatusCriteria = (deliveryStatusCriteria) => {
    const paramsForState = { ...this.state.filterParams, deliveryStatusCriteria };
    if (!isEmpty(this.state.filterParams.deliveryStatuses)) {
      this.setState({ filterParams: paramsForState }, this.fetchContacts);
    } else {
      this.setState({ filterParams: paramsForState });
    }
  }

  handleChangeStep = (stepIds) => {
    const paramsForState = { ...this.state.filterParams, stepIds };
    this.setState({ filterParams: paramsForState }, this.fetchContacts);
  }

  handleChangeSearch = (search) => {
    const paramsForState = { ...this.state.filterParams, search };
    this.setState({ filterParams: paramsForState }, this.fetchContacts);
  }

  handleModalSuccess = async () => {
    if (this.state.whichModal === MODAL_TYPES.DELETE_MODAL) {
      await this.props.destroySequenceContact(this.state.whichSeqContact.id);
    } else if (this.state.whichModal === MODAL_TYPES.BLACKLIST_MODAL) {
      await this.props.createAccountBlacklistedContact({
        account: this.props.sequence.account_id,
        contact: this.state.whichSeqContact.contact_id,
      });
    } else if (this.state.whichModal === MODAL_TYPES.REMOVE_MODAL) {
      await this.props.removeFromCampaignSequenceContact(this.state.whichSeqContact.id);
    } else if (this.state.whichModal === MODAL_TYPES.MARK_AS_FINISHED_MODAL) {
      await this.props.markAsFinishedSequenceContact(this.state.whichSeqContact.id);
    } else if (this.state.whichModal === MODAL_TYPES.UNMARK_AS_FINISHED_MODAL) {
      await this.props.unmarkAsFinishedSequenceContact(this.state.whichSeqContact.id);
    } else if (this.state.whichModal === MODAL_TYPES.MOVE_MODAL) {
      await this.props.updateBulkSequenceContact([{
        id: this.state.whichSeqContact.id,
        sequence: this.state.sequenceToMove.id,
      }]);
    }
    this.toggleModal(false);
    await this.fetchContacts();
    // show notifications
    if (this.state.whichModal === MODAL_TYPES.DELETE_MODAL) {
      this.props.showNotification(`${this.state.whichSeqContact.email} was deleted`, 'success');
    } else if (this.state.whichModal === MODAL_TYPES.BLACKLIST_MODAL) {
      this.props.showNotification(`${this.state.whichSeqContact.email} was marked as 'Do not contact'`, 'success');
    } else if (this.state.whichModal === MODAL_TYPES.REMOVE_MODAL) {
      this.props.showNotification(`${this.state.whichSeqContact.email} was removed from current campaign`, 'success');
    } else if (this.state.whichModal === MODAL_TYPES.MOVE_MODAL) {
      this.props.showNotification(`${this.state.whichSeqContact.email} was successfully moved`, 'success');
    } else if (this.state.whichModal === MODAL_TYPES.MARK_AS_FINISHED_MODAL) {
      this.props.showNotification(`${this.state.whichSeqContact.email} was marked as finished`, 'success');
    } else if (this.state.whichModal === MODAL_TYPES.UNMARK_AS_FINISHED_MODAL) {
      this.props.showNotification(`${this.state.whichSeqContact.email} was unmarked as finished`, 'success');
    }
  }

  handleBulkModalSuccess = async () => {
    const { filterParams } = this.state;
    const {
      isSelectedAllContacts,
      sequence,
    } = this.props;
    const selectedContactsOnPage = this.props.getSelectedContactsOnPage();
    const preparedParams = this.prepareParams(filterParams);
    this.toggleBulkModal(false);
    if (this.state.whichModal === MODAL_TYPES.DELETE_MODAL) {
      const objectsListToRemove = selectedContactsOnPage.map(obj => ({
        id: obj.id,
      }));
      // eslint-disable-next-line no-unused-expressions
      !isSelectedAllContacts && await this.props.destroyBulkSequenceContact(objectsListToRemove);

      if (isSelectedAllContacts) {
        this.props.showNotification(SELECT_ALL_SUCCESS, 'success');
        await this.props.destroyBulkSequenceContact(
          objectsListToRemove,
          {
            ...DEFAULT_CONTACT_QUERY_PARAMS,
            ...preparedParams,
            ...{ all: true, sequence_id: sequence.id },
          },
        );
      }
    }
    if (this.state.whichModal === MODAL_TYPES.BLACKLIST_MODAL) {
      const objectsListToSave = selectedContactsOnPage
        .filter(seqContact => !seqContact.errors.some(err => err.error_type === CONTACT_ERRORS.BLACKLISTED))
        .map(obj => ({
          account: this.props.sequence.account_id,
          contact: obj.contact_id,
        }));
      // eslint-disable-next-line no-unused-expressions
      !isSelectedAllContacts && await this.props.createBulkAccountBlacklistedContacts(objectsListToSave);

      // eslint-disable-next-line no-unused-expressions
      if (isSelectedAllContacts) {
        this.props.showNotification(SELECT_ALL_SUCCESS, 'success');
        await this.props.createBulkAccountBlacklistedContacts(
          objectsListToSave,
          {
            ...DEFAULT_CONTACT_QUERY_PARAMS,
            ...preparedParams,
            ...{ all: true, sequence_id: sequence.id },
          },
        );
      }
    }
    if (this.state.whichModal === MODAL_TYPES.REMOVE_MODAL) {
      const objectsListToRemove = selectedContactsOnPage.map(obj => ({
        id: obj.id,
      }));
      // eslint-disable-next-line no-unused-expressions
      !isSelectedAllContacts && await this.props.removeBulkFromCampaignSequenceContact(objectsListToRemove);

      if (isSelectedAllContacts) {
        this.props.showNotification(SELECT_ALL_SUCCESS, 'success');
        await this.props.removeBulkFromCampaignSequenceContact(
          objectsListToRemove,
          {
            ...DEFAULT_CONTACT_QUERY_PARAMS,
            ...preparedParams,
            ...{ all: true, sequence_id: sequence.id },
          },
        );
      }
    }
    if (this.state.whichModal === MODAL_TYPES.MARK_AS_FINISHED_MODAL) {
      const objectsListToRemove = selectedContactsOnPage.map(obj => ({
        id: obj.id,
      }));
      await this.props.markBulkAsFinishedSequenceContact(objectsListToRemove);
    }
    if (this.state.whichModal === MODAL_TYPES.UNMARK_AS_FINISHED_MODAL) {
      const objectsListToRemove = selectedContactsOnPage.map(obj => ({
        id: obj.id,
      }));
      await this.props.unmarkBulkAsFinishedSequenceContact(objectsListToRemove);
    }
    if (this.state.whichModal === MODAL_TYPES.MOVE_MODAL) {
      const objectsListToMove = selectedContactsOnPage.map(obj => ({
        id: obj.id,
        sequence: this.state.sequenceToMove.id,
      }));
      // eslint-disable-next-line no-unused-expressions
      !isSelectedAllContacts && await this.props.updateBulkSequenceContact(objectsListToMove);

      if (isSelectedAllContacts) {
        this.props.showNotification(SELECT_ALL_SUCCESS, 'success');
        await this.props.updateBulkSequenceContact(
          objectsListToMove,
          {
            ...DEFAULT_CONTACT_QUERY_PARAMS,
            ...preparedParams,
            ...{ all: true, sequence_id: sequence.id },
          },
        );
      }
    }

    // untoggle selected contact from being selected
    this.props.untoggleSelectedContactOnPage();
    // show notifications
    if (this.state.whichModal === MODAL_TYPES.BLACKLIST_MODAL && !isSelectedAllContacts) {
      this.props.showNotification(`${selectedContactsOnPage.length} contacts were blacklisted`, 'success');
    }
    if (this.state.whichModal === MODAL_TYPES.REMOVE_MODAL && !isSelectedAllContacts) {
      this.props.showNotification(`${selectedContactsOnPage.length} contacts were removed from campaign`, 'success');
    }
    if (!isSelectedAllContacts && this.state.whichModal === MODAL_TYPES.MOVE_MODAL) {
      this.props.showNotification(`${selectedContactsOnPage.length} contacts were successfully moved`, 'success');
    }
    if (this.state.whichModal === MODAL_TYPES.DELETE_MODAL && !isSelectedAllContacts) {
      this.props.showNotification(`${selectedContactsOnPage.length} contacts were successfully deleted`, 'success');
    }
    if (this.state.whichModal === MODAL_TYPES.MARK_AS_FINISHED_MODAL) {
      this.props.showNotification(`${selectedContactsOnPage.length} contacts were marked as finished`, 'success');
    }
    if (this.state.whichModal === MODAL_TYPES.UNMARK_AS_FINISHED_MODAL) {
      this.props.showNotification(`${selectedContactsOnPage.length} contacts were unmarked as finished`, 'success');
    }
    this.props.removeSelection();
    if (!isSelectedAllContacts) {
      this.fetchContacts();
    }
  }

  handleChangeAddedDate = (startAddedDate, endAddedDate) => {
    const { filterParams } = this.state;
    const filterParamsNew = { ...filterParams, startAddedDate, endAddedDate };
    if (endAddedDate && startAddedDate) {
      // fetchList only if both startAddedDate and endAddedDate are present
      this.setState({ filterParams: filterParamsNew }, this.fetchContacts);
    } else if (endAddedDate || startAddedDate) {
      // setState if startAddedDate or endAddedDate is null
      this.setState({ filterParams: filterParamsNew });
    } else if (!endAddedDate && !startAddedDate) {
      // reset search if both are null
      this.setState({ filterParams: filterParamsNew }, this.fetchContacts);
    }
  }

  handleChangeLastDeliveredDate = (startLastDeliveredDate, endLastDeliveredDate) => {
    const { filterParams } = this.state;
    const filterParamsNew = { ...filterParams, startLastDeliveredDate, endLastDeliveredDate };
    if (endLastDeliveredDate && startLastDeliveredDate) {
      // fetchList only if both startLastDeliveredDate and endLastDeliveredDate are present
      this.setState({ filterParams: filterParamsNew }, this.fetchContacts);
    } else if (endLastDeliveredDate || startLastDeliveredDate) {
      // setState if startLastDeliveredDate or endLastDeliveredDate is null
      this.setState({ filterParams: filterParamsNew });
    } else if (!endLastDeliveredDate && !startLastDeliveredDate) {
      // reset search if both are null
      this.setState({ filterParams: filterParamsNew }, this.fetchContacts);
    }
  }

  handleOnResetFilters = () => {
    const { filterParams } = this.state;
    const newParams = filterParams;
    newParams.statuses = null;
    newParams.validationStatuses = null;
    newParams.deliveryStatuses = null;
    newParams.deliveryStatusCriteria = DEFAULT_DELIVERY_STATUS_CRITERIA;
    newParams.stepIds = null;
    newParams.startAddedDate = null;
    newParams.endAddedDate = null;
    newParams.startLastDeliveredDate = null;
    newParams.endLastDeliveredDate = null;
    this.setState(
      { ...this.state, ...newParams },
      this.fetchContacts,
    );
    this.props.removeSelection();
  }

  handleOnDeleteFilter = (filter) => {
    const { filterParams } = this.state;
    const newParams = filterParams;
    switch (filter) {
      case DYNAMIC_MENU_OPTIONS.category:
        newParams.statuses = null;
        break;
      case DYNAMIC_MENU_OPTIONS.validationStatus:
        newParams.validationStatuses = null;
        break;
      case DYNAMIC_MENU_OPTIONS.deliveryStatus:
        newParams.deliveryStatuses = null;
        newParams.deliveryStatusCriteria = DEFAULT_DELIVERY_STATUS_CRITERIA;
        break;
      case DYNAMIC_MENU_OPTIONS.step:
        newParams.stepIds = null;
        break;
      case DYNAMIC_MENU_OPTIONS.added:
        newParams.startAddedDate = null;
        newParams.endAddedDate = null;
        break;
      case DYNAMIC_MENU_OPTIONS.lastDelivered:
        newParams.startLastDeliveredDate = null;
        newParams.endLastDeliveredDate = null;
        break;
      default:
        break;
    }
    this.setState(
      { ...this.state, ...newParams },
      this.fetchContacts,
    );
    this.props.removeSelection();
  }

  fetchContacts = () => {
    const preparedParams = this.prepareParams(this.state.filterParams);
    this.props.getContacts(preparedParams);
  }

  prepareParams = (params) => {
    const prepParams = { ...params };
    // in API we will consume accounts as string ( 'accountID1, accountID2' )
    if (prepParams.startAddedDate) {
      prepParams.start_added_date = removeTZ(prepParams.startAddedDate.startOf('day'));
      delete prepParams.startAddedDate;
    }
    if (prepParams.endAddedDate) {
      prepParams.end_added_date = removeTZ(prepParams.endAddedDate.endOf('day'));
      delete prepParams.endAddedDate;
    }
    if (prepParams.startLastDeliveredDate) {
      prepParams.start_last_delivered_date = removeTZ(prepParams.startLastDeliveredDate.startOf('day'));
      delete prepParams.startLastDeliveredDate;
    }
    if (prepParams.endLastDeliveredDate) {
      prepParams.end_last_delivered_date = removeTZ(prepParams.endLastDeliveredDate.endOf('day'));
      delete prepParams.endLastDeliveredDate;
    }
    Object.keys(prepParams).forEach(key => (isEmpty(prepParams[key])) && delete prepParams[key]);
    if (prepParams.deliveryStatusCriteria && prepParams.deliveryStatuses) {
      prepParams.delivery_statuses_not = prepParams.deliveryStatusCriteria.value;
    }
    if (prepParams.deliveryStatuses) {
      prepParams.delivery_statuses = flattenKeyPairArray(prepParams.deliveryStatuses, 'value').join(',');
      delete prepParams.deliveryStatuses;
    }
    if (prepParams.statuses) {
      prepParams.statuses = flattenKeyPairArray(prepParams.statuses, 'value').join(',');
    }
    if (prepParams.validationStatuses) {
      prepParams.validation_statuses = flattenKeyPairArray(prepParams.validationStatuses, 'value').join(',');
      delete prepParams.validationStatuses;
    }
    if (prepParams.ordering) prepParams.ordering = this.calculateOrdering(prepParams.ordering, this.state.orderState);
    delete prepParams.deliveryStatusCriteria;
    return prepParams;
  }

  toggleContactEditModal(open, contact) {
    this.setState({
      isContactEditModalOpen: open,
      contactUpdating: contact,
    });
  }

  handleOrdering = (ordering, e = null) => {
    // clicked on checkbox
    if (e && e.target.nodeName === 'INPUT') {
      return;
    }
    const orderState = this.state.orderState === 'asc' ? 'desc' : 'asc';
    this.setState(prevState => ({
      ...prevState,
      orderState,
      filterParams: {
        ...prevState.filterParams,
        ordering,
      },
    }), this.fetchContacts);
  };

  calculateOrdering = (property, sorting) => {
    if (sorting === 'desc' && property) {
      return `-${property}`;
    }
    return property;
  };

  renderContacts(contacts) {
    return (
      contacts.results.map((seqContact) => {
        const isSelected = this.props.isSelected(seqContact.id);
        const { handleSelectClick, showContactReplyForCurrentSequence } = this.props;
        return (
          <ContactRow
            key={`contact-row-${seqContact.id}`}
            seqContact={seqContact}
            isSelected={isSelected}
            parentComponentId={this.parentComponentId}
            handleSelectClick={handleSelectClick}
            showErrors={false}
            showContactReplyForCurrentSequence={showContactReplyForCurrentSequence}
            toggleModal={this.toggleModal}
            toggleContactEditModal={() => this.toggleContactEditModal(true, seqContact)}
            fieldsToShow={this.state.fieldsToShow}
          />
        );
      })
    );
  }

  handleCSVExport = async () => {
    this.setState(prevState => ({ ...prevState, isExporting: true }));
    const data = {
      sequenceContactIds: this.props.getSelectedContactsOnPage().map(sq => sq.id),
    };
    const params = { all: this.props.isSelectedAllContacts, sequence_id: this.props.sequence.id };
    const response = await axios.post(
      apiExportSequenceContacts(),
      data,
      { withCredentials: true, params, responseType: 'blob' },
    );
    // Create a blob from the response
    const blob = new Blob([response.data], { type: 'text/csv' });
    downloadBlob(blob, 'export.csv');

    this.setState(prevState => ({ ...prevState, isExporting: false }));
  }

  render() {
    const {
      contacts, sequence, showDuplicates,
      showDownloadErrors, onClickAddContact,
    } = this.props;
    const {
      filterParams, isModalOpen, whichModal, whichSeqContact,
      sequenceToMove, isBulkModalOpen, selectedIds, isContactEditModalOpen,
      contactUpdating, isExporting,
    } = this.state;
    const isLoading = contacts.loading || sequence.loading;
    const isSelectedOnPage = this.props.getSelectedContactsOnPage().length > 0;
    const showFieldsCount = Object.values(this.state.fieldsToShow).filter(field => field.show === true).length;

    return (
      <div className="sequence-contact-list">
        <ContactUpdateDrawer
          contactId={get(contactUpdating, 'contact_id')}
          sequenceId={sequence.id}
          sequenceContactId={get(contactUpdating, 'id')}
          isContactEditModalOpen={isContactEditModalOpen}
          toggleContactEditModal={() => this.toggleContactEditModal(false, contactUpdating)}
          onUpdate={this.fetchContacts}
        />
        <ActionsModal
          isModalOpen={isModalOpen}
          whichModal={whichModal}
          whichSeqContact={whichSeqContact}
          sequenceToMove={sequenceToMove}
          toggleModal={this.toggleModal}
          handleChangeSequence={this.handleChangeSequence}
          handleLoadSequenceOptions={this.handleLoadSequenceOptions}
          handleModalSuccess={this.handleModalSuccess}
        />
        <ActionsBulkModal
          isBulkModalOpen={isBulkModalOpen}
          getSelectedContactsOnPage={this.props.getSelectedContactsOnPage}
          sequenceToMove={sequenceToMove}
          whichModal={whichModal}
          toggleBulkModal={this.toggleBulkModal}
          selectedIds={selectedIds}
          handleChangeSequence={this.handleChangeSequence}
          handleLoadSequenceOptions={this.handleLoadSequenceOptions}
          handleBulkModalSuccess={this.handleBulkModalSuccess}
          sequenceContacts={this.props.sequenceContacts.count}
          isSelectedAllContacts={this.props.isSelectedAllContacts}
        />
        {showDuplicates &&
          <div className="card__title" ref={this.mainModalRef}>
            <h5 className="bold-text">Contacts</h5>
            <div>
              <span>Allow duplicates</span>
              {/* eslint-disable jsx-a11y/label-has-for */}
              <label className="switch">
                {/* eslint-enable jsx-a11y/label-has-for */}
                <Switch
                  onChange={this.handleAllowDuplicates}
                  checked={sequence.allow_duplicates}
                />
              </label>
            </div>
          </div>
        }
        <div className="actions">
          <div className="flex">
            <DynamicFilter
              onResetSelectedFilter={this.onResetSelectedFilter}
              menuDescription="Filter by"
              onResetFilters={this.handleOnResetFilters}
              options={[
                {
                  key: DYNAMIC_MENU_OPTIONS.deliveryStatus,
                  menuLabel: 'Status-Delivery',
                  onDeleteFilter: this.handleOnDeleteFilter,
                  filterCriteria: <Select
                    placeholder="Criteria"
                    onChange={this.handleChangeDeliveryStatusCriteria}
                    options={DELIVERY_STATUS_CRITERIA_OPTIONS}
                    value={filterParams.deliveryStatusCriteria}
                  />,
                  component: <Select
                    isMulti
                    placeholder="Status-Delivery"
                    onChange={this.handleChangeDeliveryStatuses}
                    options={DELIVERY_STATUS_OPTIONS}
                    value={filterParams.deliveryStatuses}
                  />,
                },
                {
                  key: DYNAMIC_MENU_OPTIONS.category,
                  menuLabel: 'Inbox category',
                  onDeleteFilter: this.handleOnDeleteFilter,
                  component: <Select
                    isMulti
                    placeholder="Inbox Category"
                    onChange={this.handleChangeCategories}
                    options={REPLY_STATUS_OPTIONS}
                    value={filterParams.statuses}
                    isCategorySelect
                  />,
                },
                {
                  key: DYNAMIC_MENU_OPTIONS.validationStatus,
                  menuLabel: 'Email validation status',
                  onDeleteFilter: this.handleOnDeleteFilter,
                  component: <Select
                    isMulti
                    placeholder="Email validation status"
                    onChange={this.handleChangeValidationStatus}
                    options={EMAIL_VALIDATION_STATUS_OPTIONS}
                    value={filterParams.validationStatuses}
                  />,
                },
                {
                  key: DYNAMIC_MENU_OPTIONS.stepIds,
                  menuLabel: 'Step',
                  onDeleteFilter: this.handleOnDeleteFilter,
                  component: <StepsFilter
                    placeholder="Steps"
                    onChange={this.handleChangeStep}
                    value={filterParams.stepIds}
                    sequence={sequence}
                  />,
                },
                {
                  key: DYNAMIC_MENU_OPTIONS.added,
                  menuLabel: 'Added on',
                  onDeleteFilter: this.handleOnDeleteFilter,
                  component: <DateRangePicker
                    initialStartDate={filterParams.startAddedDate}
                    initialEndDate={filterParams.endAddedDate}
                    onChange={this.handleChangeAddedDate}
                    minDate={null}
                    maxDate={moment()}
                  />,
                },
                {
                  key: DYNAMIC_MENU_OPTIONS.lastDelivered,
                  menuLabel: 'Last delivered',
                  onDeleteFilter: this.handleOnDeleteFilter,
                  component: <DateRangePicker
                    initialStartDate={filterParams.startLastDeliveredDate}
                    initialEndDate={filterParams.endLastDeliveredDate}
                    onChange={this.handleChangeLastDeliveredDate}
                    minDate={null}
                    maxDate={moment()}
                  />,
                },
              ]}
            />
          </div>
          <div className="w-100">
            <SearchInput
              onChange={this.handleChangeSearch}
              value={filterParams.search}
            />
          </div>

          <Can I="edit" a="Sequence Contact">
            <div className="flex flex-grow-1 flex-row-reverse">
              {/* bulk actions will work with selected contacts on the current page only */}
              {isSelectedOnPage &&
                <ButtonMenu btnText="Bulk actions" size="large" className="mr-2">
                  <MenuItem onClick={() => this.toggleBulkModal(true, MODAL_TYPES.DELETE_MODAL)}>
                    Delete
                  </MenuItem>
                  <MenuItem onClick={() => this.toggleBulkModal(true, MODAL_TYPES.MOVE_MODAL)}>
                    Move to different sequence
                  </MenuItem>
                  <MenuItem onClick={() => this.toggleBulkModal(true, MODAL_TYPES.REMOVE_MODAL)}>
                    Remove from campaign
                  </MenuItem>
                  <MenuItem onClick={() => this.toggleBulkModal(true, MODAL_TYPES.BLACKLIST_MODAL)}>
                    Blacklist
                  </MenuItem>
                  {!this.props.getSelectedContactsOnPage().every(seqContact => seqContact.status_manually_finished_date)
                    &&
                    <MenuItem onClick={() => this.toggleBulkModal(true, MODAL_TYPES.MARK_AS_FINISHED_MODAL)}>
                      Mark as finished
                    </MenuItem>
                  }
                  {this.props.getSelectedContactsOnPage().some(seqContact => seqContact.status_manually_finished_date)
                    &&
                    <MenuItem onClick={() => this.toggleBulkModal(true, MODAL_TYPES.UNMARK_AS_FINISHED_MODAL)}>
                      Unmark as finished
                    </MenuItem>
                  }
                  <MenuItem onClick={isExporting ? () => {} : this.handleCSVExport}>
                    {isExporting ?
                      <span className="loading-dots">Exporting</span> :
                      <React.Fragment>Export to CSV</React.Fragment>
                    }
                  </MenuItem>
                </ButtonMenu>
              }

              {showDownloadErrors &&
              <div className="btn-container mr-2">
                <a
                  download
                  type="text/csv"
                  href={getSequenceErrorsCSVLink(this.props.sequence.id)}
                  className={
                    `btn btn-danger ${isLoading || contacts.contacts_with_errors > 0 ? '' : 'disabled'}`
                  }
                >
                  <p>
                    <AlertOutlineIcon />
                    {isLoading ?
                      <span className="loading-dots">Download errors</span> :
                      <React.Fragment>Download errors ({contacts.contacts_with_errors})</React.Fragment>
                    }
                  </p>
                </a>
              </div>
              }
            </div>
          </Can>


          <Can I="add" a="Contact">
            <div className="flex">
              <Button
                color="primary"
                variant="contained"
                size="large"
                startIcon={<PlusCircleOutlineIcon />}
                onClick={onClickAddContact}
              >
                Add Contacts
              </Button>
            </div>
          </Can>
        </div>

        <div className="flex pt-6 justify-between">
          <HideFields
            fieldsToShow={this.state.fieldsToShow}
            onFieldsToShowChange={newFieldsToShow =>
              this.setState(prevState => ({ ...prevState, fieldsToShow: newFieldsToShow }))}
            cookieKey="sequenceContactsShowFields"
            style={{ minWidth: 'max-content' }}
          />
          {!isLoading &&
            <ContactStatsSlim
              totalContacts={contacts.count}
              optouts={contacts.optouts}
              blacklisted={contacts.blacklisted}
              bounces={contacts.bounces}
              delivered={contacts.delivered}
              uniqueDelivered={sequence.stat_unique_delivered}
              uniqueAttemptedSends={sequence.stat_unique_attempted_sends}
              opened={sequence.stat_unique_opens}
              replies={sequence.stat_unique_replies}
            />
          }
        </div>


        <div className="material-table__wrap mt-4">
          {isLoading ? (
            <div className="loader"><LoadingIcon /></div>
          ) : (
            <>
              <Table className="volt-table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      key="full_name"
                      onClick={e => this.handleOrdering('full_name', e)}
                      className="flex whitespace-nowrap"
                    >
                      <Can I="edit" a="Sequence Contact">
                        <Checkbox
                          indeterminate={this.props.isIndeterminate()}
                          checked={this.props.isAllChecked()}
                          onChange={this.props.handleSelectAll}
                        />
                      </Can>
                      <TableSortLabel
                        order={this.state.orderState}
                        orderBy={filterParams.ordering}
                        property="full_name"
                      >
                        Full name
                      </TableSortLabel>
                    </TableCell>
                    <TableCell
                      key="outlet"
                      onClick={() => this.handleOrdering('outlet.name')}
                    >
                      <TableSortLabel
                        order={this.state.orderState}
                        orderBy={filterParams.ordering}
                        property="outlet"
                      >
                        Outlet
                      </TableSortLabel>
                    </TableCell>
                    {Object.values(this.state.fieldsToShow).map(field => (
                      field.show && (
                        <TableCell
                          key={field.label}
                          alignRight={field.align === 'right'}
                          onClick={field.orderingField ? () => this.handleOrdering(field.orderingField) : () => {}}
                          className="sortable truncate-text--200 whitespace-nowrap"
                        >
                          {field.orderingField ?
                            <TableSortLabel
                              order={this.state.orderState}
                              orderBy={filterParams.ordering}
                              property={field.orderingField}
                            >
                              {field.headerContent || field.label}
                            </TableSortLabel> : field.headerContent || field.label}
                        </TableCell>
                      )
                    ))}
                    <TableCell />
                  </TableRow>
                </TableHead>
                {this.props.isAllChecked() &&
                  this.props.getSelectedContactsOnPage().length < this.props.sequenceContacts.count &&
                  <tr className="material-table__row--contacts-info">
                    {!this.props.isSelectedAllContacts ?
                      <td colSpan={showFieldsCount + 3}>
                        {contacts.results.length} contacts are selected on this page.
                        <span onClick={() => this.props.onSelectedAllContacts(true)} aria-hidden="true">
                              Click to select all {this.props.sequenceContacts.count}
                        </span>
                      </td> :
                      <td colSpan={showFieldsCount + 3}>
                          Selected all {this.props.sequenceContacts.count} contacts
                      </td>
                    }
                  </tr>
                }
                <TableBody>
                  {(isLoading) && <ContactsLoader />}
                  {(contacts.results.length > 0 && !isLoading) &&
                    this.renderContacts(contacts)
                  }
                </TableBody>
              </Table>
              <NoResults loading={isLoading} results={contacts.results} />
            </>
          )}
        </div>
        <Pagination
          items={this.props.contacts}
          onChangePage={this.props.getContacts}
          params={this.prepareParams(filterParams)}
        />
      </div>
    );
  }
}

export default compose(connect(
  state => ({
    sequences: state.sequences,
    sequenceContacts: state.sequenceContacts,
  }),
  {
    getSequences,
    updateSequence,
    updateSequenceContact,
    destroySequenceContact,
    updateBulkSequenceContact,
    destroyBulkSequenceContact,
    createAccountBlacklistedContact,
    removeFromCampaignSequenceContact,
    createBulkAccountBlacklistedContacts,
    removeBulkFromCampaignSequenceContact,
    markAsFinishedSequenceContact,
    unmarkAsFinishedSequenceContact,
    markBulkAsFinishedSequenceContact,
    unmarkBulkAsFinishedSequenceContact,
  },
))(withContactList(SequenceContactList));
